<template lang="html">
  <tr>
    <slot></slot>
  </tr>
</template>

<script lang="js">

export default  {
	name  : 'row',
	props : [],
	mounted () {

	},
	data () {
		return {

		}
	},
	methods : {

	},
	computed : {

	},
}

</script>

<style scoped lang="scss">

</style>
